export default "__VITE_ASSET__BNJBX5DF__"